import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import qmaTemplate from '@/shared/http/repositories/business/qmaTemplate'
import { loading } from '@/shared/utils/UIHelper'

export default {
  props: ['templateid'],
  name: 'panelTemplate',
  components: {},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      dataTemplatePainelQMA: {}
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      loading.push()
      qmaTemplate.GetQMATemplatePainel(this.templateid)
        .then((Response) => {
          loading.pop()
          this.dataTemplatePainelQMA = Response.data
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/panelTemplate/panelTemplate.js